module.exports = __webpack_public_path__ + "img/icon-sample.be794798.svg";